
import React from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import SidebarLogo from "./SidebarLogo";
import SidebarNavigation from "./SidebarNavigation";
import HelpSection from "./HelpSection";
import { NavItem } from "./types";

interface MobileSidebarProps {
  navItems: NavItem[];
  isOpen: boolean;
  onClose: () => void;
}

const MobileSidebar: React.FC<MobileSidebarProps> = ({ navItems, isOpen, onClose }) => {
  return (
    <div
      className={cn(
        "fixed inset-0 z-40 lg:hidden transition-opacity duration-300",
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      )}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <aside className="absolute top-0 left-0 h-full w-64 bg-card shadow-xl animate-slide-up">
        <div className="flex items-center justify-between p-4">
          <SidebarLogo isCollapsed={false} />
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700"
            aria-label="Close menu"
          >
            <X size={20} className="text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        <SidebarNavigation navItems={navItems} isCollapsed={false} onItemClick={onClose} />

        <div className="p-4 mt-auto">
          <HelpSection isCollapsed={false} onClick={onClose} />
        </div>
      </aside>
    </div>
  );
};

export default MobileSidebar;
